class DeepSet<T> {
    private set: Set<string>;
    private capacity: number;
    public size: number;

    constructor(initial?: Array<T>, capacity?: number) {
        this.set = new Set();
        if (initial) {
            initial.forEach((e) => this.set.add(JSON.stringify(e)));
        }
        const clampedCapacity = Math.max(capacity || 0, 0);
        this.capacity = clampedCapacity || Infinity;
        this.size = this.set.size;
    }

    private updateSize() {
        this.size = this.set.size;
    }

    public values(): T[] {
        return Array.from(this.set.values()).map((e) => JSON.parse(e) as T);
    }
    public Map<U>(callbackfn: (value: T, index: number, array: T[]) => U, thisArg?: any): U[] {
        return this.values().map(callbackfn, thisArg);
    }
    public has(value: T): boolean {
        return this.set.has(JSON.stringify(value));
    }

    public add(element: T): this {
        if (this.size < this.capacity) {
            this.set.add(JSON.stringify(element));
            this.updateSize();
        }
        return this;
    }
    public delete(element: T) {
        const deleted = this.set.delete(JSON.stringify(element));
        this.updateSize();
        return deleted;
    }
    public clear(): void {
        this.set.clear();
        this.updateSize();
    }

    public concat(elements: T[]): this {
        elements.forEach((e) => this.add(e));
        return this;
    }
}

export default DeepSet;
